import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import {
  AppShell,
  EmployeeAvatar,
  LanguageSwitcher,
  tngTheme,
} from "@tngtech/tng-ui";
import { useContext, useMemo } from "react";
import { Outlet } from "react-router";
import { useAuthentication } from "../../src/auth/useAuthentication.ts";
import { useUserEmailAddress } from "../../src/auth/useUserEmailAddress.ts";
import { RuntimeConfigContext } from "../../src/config/RuntimeConfigContext";
import { InternationalizationContext } from "../../src/i18n/InternationalizationContext";
import { LinkAdapter } from "../../src/pages/LinkAdapter.tsx";
import { usePortraitsTranslator } from "./i18n/translator";
import { PortraitsSidebar } from "./PortraitsSidebar";

export const PortraitsApp = () => {
  const theme = useMemo(
    () => tngTheme({ defaultLinkComponent: LinkAdapter }),
    [],
  );
  const { language, setLanguage } = useContext(InternationalizationContext);
  const translator = usePortraitsTranslator();
  const userEmail = useUserEmailAddress();
  const { isTestSystem } = useContext(RuntimeConfigContext);
  const { isAuthenticated } = useAuthentication();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppShell>
        <AppShell.Topbar
          projectTitle={translator(isTestSystem ? "appTitleTest" : "appTitle")}
          color={isTestSystem ? "secondary" : undefined}
          apps={isAuthenticated ? undefined : []}
        >
          <LanguageSwitcher
            availableLanguages={["DE", "EN"]}
            changeLanguage={(selectedLanguage) => setLanguage(selectedLanguage)}
            currentlySelectedLanguage={language}
          />
          <EmployeeAvatar email={userEmail} />
        </AppShell.Topbar>
        <AppShell.Sidebar>
          <PortraitsSidebar />
        </AppShell.Sidebar>
        <AppShell.Main>
          <Box component="main" padding={3}>
            <Outlet />
          </Box>
        </AppShell.Main>
      </AppShell>
    </ThemeProvider>
  );
};
